module.exports = __webpack_public_path__ + "img/RASolidA-Light.b1364e1c.jpeg";